import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { map, take } from 'rxjs/operators';

export let google;

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {
  googleMapsLoaded = false;
  googleMapsLoaded$ = new BehaviorSubject(false);

  loadGoogleScript(url, _renderer) {
    const se: any = document.createElement('script');
    const responseSubj = new Subject();
    se.type = 'text/javascript';
    se.async = true;
    // se.defer = true;
    se.id = 'google-autocomplete';
    se.src = url;
    se.onload = se['onreadystatechange'] = () => {
      this.waitForInitGoogleMaps(responseSubj);
    };

    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(se, s);

    return responseSubj;
  }

  waitForInitGoogleMaps(subject): void {
    if (!window['google']) {
      setTimeout(() => {
        this.waitForInitGoogleMaps(subject);
      }, 1);
    } else {
      subject.next(true);
    }
  }

  loadGoogleAutoComplete(language: string, _renderer) {
    const url = `https://maps.googleapis.com/maps/api/js?key=AIzaSyArzykav75Tm9nMV80m1T4gC647S_Dc4fM&libraries=places&v=weekly&language=${language}`;
    return this.loadGoogleScript(url, _renderer)
      .pipe(
        take(1),
        map(() => {
          this.googleMapsLoaded = true;
          this.googleMapsLoaded$.next(true);
        })
      )
      .subscribe();
  }

  reloadAutoCompleteScript(lang, _renderer) {
    this.googleMapsLoaded = false;
    this.googleMapsLoaded$.next(false);
    if (document.getElementById('google-autocomplete')) {
      _renderer.removeChild(this._document, document.getElementById('google-autocomplete'));
      // @ts-ignore
      google = null;
      // @ts-ignore
      window.google = undefined;
    }

    return this.loadGoogleAutoComplete(lang, _renderer);
  }

  constructor(@Inject(DOCUMENT) private _document: Document) {}
}
